export default __webpack_public_path__ + "static/media/bagel-meets-bagel.75fd37bb.png";